import { Box, Typography } from '@mui/material'
import PrimaryButton from '../common/PrimaryButton'
import { programInnerSx } from './programLayout'
import { MOBILE_MQ, mobileBodyTextSx, mobileSectionTitleSx } from '../../theme/mobileLayout'
import { scale } from '../../theme/scale'

export default function ProgramPageHero({ title, subtitle, cta, ctaLink = '/contact', subtitleSx = {} }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: '20px',
        maxWidth: 1200,
        mx: 'auto',
        ...programInnerSx,
      }}
    >
      <Typography
        component="h1"
        sx={{
          ...mobileSectionTitleSx,
          fontSize: { ...mobileSectionTitleSx.fontSize, md: 56, lg: 72, xl: scale.fontSize.display },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          [MOBILE_MQ]: { fontSize: 28 },
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          ...mobileBodyTextSx,
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          maxWidth: 1200,
          ...subtitleSx,
        }}
      >
        {subtitle}
      </Typography>

      {cta && (
        <PrimaryButton to={ctaLink}>
          {cta}
        </PrimaryButton>
      )}
    </Box>
  )
}
